export const additionalScoreWeight = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
    fifth: 5
};
export function sortHelper(key) {
    return additionalScoreWeight[Object.keys(additionalScoreWeight).find(y => key.toLowerCase().indexOf(y) > -1) || 0];
}
//# sourceMappingURL=sortScore.js.map